module.exports = __webpack_public_path__ + "img/story-digitalisierung-im-handwerk.a73ce0a5.jpg";